import oss from 'src/config/brandings/oss/index.js'
import bid from 'src/config/brandings/bid/index.js'
import toll from 'src/config/brandings/toll/index.js'
import sdui from 'src/config/brandings/default/index.js'
import pupil from 'src/config/brandings/pupil/index.js'
import konecto from 'src/config/brandings/konecto/index.js'
import bycs from 'src/config/brandings/bycs/index.js'
import untis from 'src/config/brandings/untis/index.js'
import univention from 'src/config/brandings/univention/index.js'

export const brandings = {
  OSS: oss,
  BID: bid,
  TOLL: toll,
  PUPIL: pupil,
  'KONECTO-SDUI': konecto,
  BYCS: bycs,
  UNIVENTION: univention,
  UNTIS: untis,
  DEFAULT: sdui
}
